import React from "react";
import { cn } from "@core/utils/domUtil";
import { cva, type VariantProps } from "class-variance-authority";

interface BulletListProps {
  children: React.ReactNode;
  className?: string;
}

const bulletListVariants = cva("lg:text-md  w-full list-outside pl-5 text-left text-[12px] leading-[1.75] [&>li]:break-words", {
  variants: {
    variant: {
      default: "list-disc",
      decimalParenthesis: "list-decimal-parenthesis",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export default function BulletList({ children, className = "", variant = "default" }: BulletListProps & VariantProps<typeof bulletListVariants>) {
  return <ul className={cn(bulletListVariants({ variant }), className)}>{children}</ul>;
}
